const toTime = (dateString)=>{
    if (Number.isNaN(Date.parse(dateString))) return '';
    const date = new Date(dateString);
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
};
export { toTime };
